import React, { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import moment from 'moment';
import { formatNumber } from '../../../../../../utility/helper';
import { FaArrowLeft, FaArrowRight, FaEdit, FaRegTrashAlt } from 'react-icons/fa';

const MovementComponent = ({ viewTransaction, viewFutureTransaction, handleOptionSelect, confirmDelete, setLimit, limit, setPage, page }) => {
  const [loading, setLoading] = useState(false);

  const onPageChange = (e) => {
    setPage(e.page);
    setLimit(e.rows);
  };

  const reasonTemplate = (rowData) => {

    return rowData.remark ? rowData.remark : "-";
  };

  const quantityTemplate = (rowData) => {

    return rowData.quantity ? rowData.quantity : "-";
  };

  const actionBodyTemplate = (rowData) => {

    return (
      <div>
        <button disabled={rowData?.is_initial} className={`focus:outline-none mr-2 ${rowData?.is_initial ? 'text-gray-400 cursor-not-allowed' : 'text-secondary'
          }`} >
          <FaEdit
            onClick={() => {
              if (!rowData?.is_default) {
                handleOptionSelect(rowData.type, "Update", rowData);
              }
            }}
          />
        </button>
        <button disabled={rowData?.is_initial} className={`focus:outline-none ${rowData?.is_initial ? 'text-gray-400 cursor-not-allowed' : 'text-expense'
          }`} >
          <FaRegTrashAlt
            onClick={() => {
              if (!rowData?.is_default) {
                confirmDelete(rowData);
              }
            }}
          />
        </button>
      </div>
    );
  };

  const dateTemplate = (rowData) => {
    return (moment(rowData.date).format('DD-MM-YYYY'));
  };

  const cashTemplate = (rowData) => {
    const cashValue = rowData.amount ? rowData.amount : "";
    const type = rowData.type?.toUpperCase();

    return (type === "OUT" || type === "EXPENSE")
      ? <div className='text-expense'>-{formatNumber(cashValue)}</div>
      : (type === "IN" || type === "INCOME")
        ? <div className='text-secondary'>{formatNumber(cashValue)}</div>
        : null;
  };

  const CostPriceTemplate = (rowData) => {
    const cashValue = rowData.cost_price || "";
    const type = rowData.type?.toUpperCase();

    if (type === "OUT" || type === "EXPENSE") {
      return cashValue == 0 ? (
        "-"
      ) : (
        <div className="text-expense">-{formatNumber(cashValue)}</div>
      );
    }

    if (type === "IN" || type === "INCOME") {
      return cashValue == 0 ? (
        "-"
      ) : (
        <div className="text-secondary">{formatNumber(cashValue)}</div>
      );
    }

    return null;
  };

  return (
    <div>
      <DataTable
        value={viewTransaction.transactions}
        className="transaction mt-3"
        sortMode="multiple"
        // paginator
        rows={limit}
        totalRecords={viewTransaction.total}
        first={page * limit}
        onPage={onPageChange}
        loading={loading}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column field="date" header="Date" body={dateTemplate} />
        <Column field="type" header="Transaction Type" style={{ width: '13%' }} />
        <Column field="remark" header="Reason" body={reasonTemplate} style={{ width: '10%' }} />
        <Column field="quantity" header="Quantity" body={quantityTemplate} align="right" style={{ width: '10%' }} />
        <Column field="cost_price" header="Unit Price" body={CostPriceTemplate} align="right" style={{ width: '10%' }} />
        <Column field="asset_type_name" header="Asset" style={{ width: '13%' }} align="right" />
        <Column field="amount" header="Cash" body={cashTemplate} align="right" style={{ width: '16%' }} />
        <Column field="Action" header="Action" body={actionBodyTemplate} style={{ width: "15%" }} align="right" />
      </DataTable>
      {viewTransaction?.total > limit && (
        <div className={`flex gap-3 items-center px-3 pt-10 text-secondary ${page > 0 ? 'justify-between' : 'justify-end'}`}>
          {page > 0 && (
            <button
              onClick={() => {
                setPage((prevPage) => prevPage - 1);
              }}
              className="flex items-center gap-1"
            >
              <FaArrowLeft />
              View Previous
            </button>
          )}
          <button
            onClick={() => {
              const maxPage = Math.ceil(viewTransaction?.total / limit) - 1;
              if (page < maxPage) {
                setPage((prevPage) => prevPage + 1);
              }
            }}
            className="flex items-center gap-1"
          >
            View Next
            <FaArrowRight />
          </button>
        </div>
      )}
      <div className='border-b border-[rgb(35,135,159)] mt-16'>Future Cash Flow</div>
      <DataTable
        value={viewFutureTransaction.transactions}
        className="transaction headerDisble"
        sortMode="multiple"
        // paginator
        rows={limit}
        totalRecords={viewFutureTransaction.total}
        first={page * limit}
        // onPage={(e) => {
        //   setPage(e.page);
        //   setLimit(e.rows);
        // }}
        // loading={loading}
        emptyMessage="No data available"
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
        currentPageReportTemplate="{first} to {last} of {totalRecords}"
      >
        <Column field="date" header="Date" body={dateTemplate} />
        <Column field="type" header="Transaction Type" style={{ width: '13%' }} />
        <Column field="remark" header="Reason" body={reasonTemplate} style={{ width: '10%' }} />
        <Column field="quantity" header="Quantity" body={quantityTemplate} align="right" style={{ width: '10%' }} />
        <Column field="cost_price" header="Unit Price" body={CostPriceTemplate} align="right" style={{ width: '10%' }} />
        <Column field="asset_type_name" header="Asset" style={{ width: '13%' }} align="right" />
        <Column field="amount" header="Cash" body={cashTemplate} align="right" style={{ width: '16%' }} />
        <Column field="Action" header="Action" body={actionBodyTemplate} style={{ width: "15%" }} align="right" />
      </DataTable>
    </div>
  );
};

export default MovementComponent;
